var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-file-dropzone',{attrs:{"accept":"application/json"},on:{"input":_vm.processFile}})
}
var staticRenderFns = []

export { render, staticRenderFns }